import cn from 'classnames';
import React from 'react';

const TIMER_UNIT_STYLE = { width: 29, height: 30 };

interface CountdownTimerDisplayProps {
  timeParts: { hours: string; minutes: string; seconds: string };
  isUrgency: boolean;
  countdownBackgroundColor?: string;
  countdownUrgencyBackgroundColor?: string;
  className?: string;
}

/**
 * Renders the HH:MM:SS countdown timer pill for the promo bar.
 * Switches background and text colour when `isUrgency` is true.
 */
const CountdownTimerDisplay: React.FC<CountdownTimerDisplayProps> = ({
  timeParts,
  isUrgency,
  countdownBackgroundColor,
  countdownUrgencyBackgroundColor,
  className,
}) => (
  <div
    data-test="promobar-countdown-timer"
    className={cn('flex h-8 items-center gap-0.5 rounded px-2', className)}
    style={{
      backgroundColor: isUrgency
        ? (countdownUrgencyBackgroundColor ?? '#FFF0EF')
        : (countdownBackgroundColor ?? '#EAF3FF'),
      color: isUrgency ? '#EC2220' : '#19335A',
    }}
  >
    {[timeParts.hours, timeParts.minutes, timeParts.seconds].map((part, i) => (
      <React.Fragment key={i}>
        {i > 0 && <span className="font-mindset text-2xl font-normal">:</span>}
        <span
          className="font-mindset flex items-center justify-center text-2xl font-normal tabular-nums"
          style={TIMER_UNIT_STYLE}
        >
          {part}
        </span>
      </React.Fragment>
    ))}
  </div>
);

export default CountdownTimerDisplay;
